import React, { forwardRef, useCallback } from "react";
import CourtSvg1 from "./CourtSvg1";
import DeployedTokens from "./DeployedTokens";
import styles from './court.module.css'
import { courtPlayerActionImagesForZones } from "./court.data";

const OuterCourt = forwardRef(({ courtOuterSvgId, viewBox, currentCommentary, showZoneOnMobileScreen, makeSelectable, showHoveredTooltip, selectedZones, zonesToBeHighlighted, hideZoneName, isLiveGame = false, teamDetails, isDeployTokenPage = false, hideHover = false, purchasedTokens, disableTokenHover=false }, svgRef) => {
  const isMatchUI = isLiveGame || currentCommentary?.matchStatus === "ENDED" || currentCommentary?.matchStatus === "FINISHED";
  const _selectedZone = useCallback((_zone, checkForLastIndex) => {
    if(checkForLastIndex) {
      if (zonesToBeHighlighted && zonesToBeHighlighted?.length > 0) {
        return zonesToBeHighlighted[zonesToBeHighlighted?.length - 1] === _zone
      }
      return false;
    }

    if (zonesToBeHighlighted && zonesToBeHighlighted?.length > 0) {
      return zonesToBeHighlighted?.find(z => z === _zone)
    }

    if (selectedZones && selectedZones?.length > 0) {
      return selectedZones?.find(z => z === _zone)
    }

  }, [zonesToBeHighlighted, selectedZones]);

  return (
    <svg
      id={courtOuterSvgId}
      viewBox={`${viewBox.x} ${viewBox.y} ${viewBox.w} ${viewBox.h}`}
      ref={svgRef}
      fill="none"
      width="100%"
      height="100%"
      style={{ overflow: "visible" }} // Ensure team names outside are visible
    >
      <g transform="translate(175, -45)">
        <CourtSvg1
          showHoveredTooltip={showHoveredTooltip}
          makeSelectable={makeSelectable}
          _selectedZone={_selectedZone}
          hideZoneName={hideZoneName}
          isLiveGame={isLiveGame}
          teamDetails={teamDetails}
          hideHover={hideHover}
          showZoneOnMobileScreen={showZoneOnMobileScreen}
          currentCommentary={currentCommentary}
        />

        {purchasedTokens && purchasedTokens?.length > 0 && (isDeployTokenPage || isLiveGame) && (
          <DeployedTokens purchasedTokens={purchasedTokens} disableTokenHover={disableTokenHover} />
        )}

        {/* Live Game on court images */}
        {courtPlayerActionImagesForZones?.map((zone, key) => {
          const ACTION_IMAGE_SIZE = 150;
          const offset = (200 - ACTION_IMAGE_SIZE) / 2; // Centers the smaller image within the original 200px coordinate space

          if(isLiveGame && zone?.zone?.toString() && _selectedZone(zone.zone.toString()) && currentCommentary?.selectedActionImageofPlayers) {
            return (
              <foreignObject
                key={key}
                x={zone.x + offset + (zone.xOffset || 0)}
                y={zone.y + offset + (zone.yOffset || 0)}
                className={styles.action_image_container}
                width={ACTION_IMAGE_SIZE}
                height={ACTION_IMAGE_SIZE}
              >
                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img
                    src={currentCommentary?.selectedActionImageofPlayers}
                    className={styles.zoneImage}
                  />
                </div>
              </foreignObject>
            )
          }
          return null;
        })}
      </g>
    </svg>
  );
});

OuterCourt.displayName = "OuterCourt";

export default OuterCourt;
